"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDeviceSize = void 0;

var _useWindowDimensionsContext = require("./useWindowDimensionsContext");

var _useBreakpoint = require("./useBreakpoint");

var useDeviceSize = function useDeviceSize() {
  var _useWindowDimensionsC = (0, _useWindowDimensionsContext.useWindowDimensionsContext)(),
      deviceWidth = _useWindowDimensionsC.deviceWidth;

  return (0, _useBreakpoint.useBreakpoint)(deviceWidth);
};

exports.useDeviceSize = useDeviceSize;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/hooks/useDeviceSize.js
// module id = 880
// module chunks = 209 210 211 212